import React from "react"
import {connect} from 'react-redux'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// core components
import GridContainer from "components/GridContainer"
import GridItem from "components/GridItem"
import Clearfix from "components/Clearfix"
import Card from "components/Card"
import CardBody from "components/CardBody"
import CardHeader from "components/CardHeader"
import CardIcon from "components/CardIcon"
import Table from "components/Table"

// assets
import userProfileStyles from "./userProfileStyles.jsx"
import NotificationsIcon from "@material-ui/icons/NotificationsTwoTone";
import { systemService } from "../../_services";
import Check from "@material-ui/icons/Check";
import Checkbox from "@material-ui/core/Checkbox";
import { Alert } from "@mui/material";

// Services

class Notifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      settings: {},
      mp_state: {},
      loading: false
    }
  }

  componentDidMount() {
    systemService.getNotificationSettings(res => {
      this.setState({settings: res.settings})
    })
    systemService.getNotificationState(res => {
      this.setState({mp_state: res})
    })
  }

  handleToggle = (device_serial) => () => {
    const {settings} = this.state;
    if (Object.keys(settings).includes(device_serial)) {
      this.setState({settings: { ...settings, [device_serial]: {"mobile_push": !settings[device_serial]["mobile_push"]}}})
      systemService.updateNotificationSettings({[device_serial]: {"mobile_push": !settings[device_serial]["mobile_push"]}}, res=>{
        systemService.getNotificationSettings(res => {
          this.setState({settings: res.settings})
        })
      })
    } else {
      this.setState({settings: { ...settings, [device_serial]: {"mobile_push": true}}})
      systemService.updateNotificationSettings({[device_serial]: {"mobile_push": true}}, res=>{
        systemService.getNotificationSettings(res => {
          this.setState({settings: res.settings})
        })
      })
    }
  };

  render() {
    const {classes, all_devices, deployments, locations} = this.props;
    const {settings, mp_state} = this.state;

    let deployments_per_device = {}
    if (deployments) {
      Object.keys(deployments).forEach((deployment_id) => {
        let deployment = deployments[deployment_id]
        deployments_per_device[deployment["device_serial"]] = deployment["location_id"]
      })
    }

    let all_devices_extended = []


    let previous_location_name = ""
    let previous_device_name = ""

    all_devices.filter(device => device.life_cycle_stage !== "DECOMMISSIONED").filter(device => ["LUMION_FIX", "DIV01"].includes(device.device_type)).map((device) => {
      let location = {"name": "loading..."}
      if (locations && deployments && deployments_per_device) {
        if (device.serial in deployments_per_device) {
          location = locations[deployments_per_device[device.serial]]
        } else {
          location = {"name": "Not Deployed..."}
        }
      }
      return {
        ...device,
        location: location ? location["name"] : "Not Deployed...",
        push_enabled: settings  && settings[device.serial]? settings[device.serial]["mobile_push"] : false
      }
    }).sort((a, b) => {
      if (a.location === b.location) {
        if (a.device_name === b.device_name) {
          if (a.device_serial > b.device_serial) return 1;
          if (a.device_serial < b.device_serial) return -1;
          return 0;
        }
        if (a.device_name > b.device_name) return 1;
        if (a.device_name < b.device_name) return -1;
        return 0;
      }

      if (a.location === "Not Deployed...") return 1
      if (b.location === "Not Deployed...") return -1
      if (a.location > b.location) return 1;
      if (a.location < b.location) return -1;
      return 0;
    }).forEach((t) => {
      let location_name = t["location"] === previous_location_name ? "" : t["location"]
      let device_name = t["device_name"] === previous_device_name ? "" : t["device_name"]
      previous_location_name = t["location"]
      previous_device_name = t["device_name"]

      all_devices_extended.push({
        ...t,
        location: location_name,
        device_name: device_name,
      })
    })

    let nr_mobile_push_devices_enabled = Object.keys(settings).map((device_serial)=>(settings[device_serial])).filter(setting => setting.mobile_push).length

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="primary" icon>
                  <CardIcon color="primary">
                    <NotificationsIcon/>
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>
                    {"Notifications"}
                  </h4>
                </CardHeader>
                <CardBody>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      {nr_mobile_push_devices_enabled > 70 &&
                        <Alert severity={"warning"}>You have already selected {nr_mobile_push_devices_enabled} devices to receive notifications, the max is 75</Alert>
                      }
                      {mp_state.nr_active_subscriptions === 0 &&
                        <Alert severity={"warning"}>No subscriptions found, are the notifications enabled in your Octiva Application?</Alert>
                      }
                      <Table
                        tableHeaderColor="primary"
                        style={{fontSize: '10px'}}
                        tableData={[
                          [<b>{"Location"}</b>, <b>{"Device Serial"}</b>, <b>{"Device Name"}</b>, <b>{"Device Type"}</b>, <b>Push notifications enabled?</b>],
                          ...all_devices_extended.map((device)=>{
                            return [
                              device.location,
                              device.serial,
                              device.device_type,
                              device.name,
                              <Checkbox
                                checked={device.push_enabled}
                                tabIndex={-1}
                                disabled={!device.push_enabled && nr_mobile_push_devices_enabled >= 75}
                                onClick={this.handleToggle(device.serial)}
                                checkedIcon={<Check className={classes.checkedIcon}/>}
                                icon={<Check className={classes.uncheckedIcon}/>}
                                classes={{
                                  checked: classes.checked,
                                  root: classes.checkRoot
                                }}
                              />
                            ]
                          }),
                          ["", "", "", "", ""]
                        ]}
                      />
                    </GridItem>
                  </GridContainer>
                  <Clearfix/>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    )
  }
}


function mapStateToProps(state) {
  const {all_devices} = state.device_fleet
  const {deployments, locations} = state.location

  return {
    all_devices, deployments, locations,
  }
}


export default withStyles(userProfileStyles)(connect(mapStateToProps)(Notifications))
